import styled from "styled-components";
import { getTheme, } from "@bracket/ui/themes";

import type { ThemePalette, } from "@bracket/ui/types";
import type { ColorDeclaration, HorizontalAlignment, VerticalAlignment, FontWeight, SizeVariant, TypeVariant, } from "@bracket/ui/types";



export const TextNode = styled.span<{
	as?: Element;
	$color?: keyof ThemePalette|ColorDeclaration|"inherit";
	$opacity?: number;
	$variant?: TypeVariant;
	$size?: SizeVariant;
	$align?: VerticalAlignment;
	$justify?: HorizontalAlignment;
	$font?: string;
	$numeric?: boolean;
	$weight?: FontWeight;
	$lineHeight?: string;
	$hide?: boolean;
	$margin?: string;
	$bold?: boolean;
	$light?: boolean;
	$dark?: boolean;
	$frame?: boolean;
	$indent?: boolean|number;
	$flow?: "stream"|"stack";
	$nowrap?: boolean;
	$debug?: boolean;
}>`
	text-rendering: optimizeLegibility;

	${({ as, }) => as === "div" && `display: flex; flex-direction: row; gap: 0.25rem;`}
	color: ${({ $variant = "p", $size = "md", $color,  }) => $color ? $color in getTheme() ? getTheme()[$color as keyof ThemePalette] : $color as ColorDeclaration : $variant === "p" ? getTheme().typeface.p[$size]?.color : getTheme().typeface[$variant].color };
	font-family: ${({ $variant = "p", $size = "md", }) => $variant === "p" ? getTheme().typeface.p[$size]?.font : getTheme().typeface[$variant].font };
	font-weight: ${({ $variant = "p", $size = "md", }) => $variant === "p" ? getTheme().typeface.p[$size]?.weight : getTheme().typeface[$variant].weight };
	font-size: ${({ $variant = "p", $size = "md", }) => $variant === "p" ? getTheme().typeface.p[$size]?.size : getTheme().typeface[$variant].size };
	line-height: ${({ $variant = "p", $size = "md", }) => $variant === "p" ? getTheme().typeface.p[$size]?.lineHeight : getTheme().typeface[$variant].lineHeight };


	${({ $numeric }) => $numeric && `font-family: Space Mono;`}
	${({ $weight }) => $weight !== undefined && `font-weight: ${$weight};`}
	${({ $align }) => $align && `align-items: ${$align};`}
	${({ $justify }) => $justify && `text-align: ${$justify};`}
	${({ $hide }) => $hide && `display: none!important;`}
	${({ $opacity }) => $opacity !== undefined && `opacity: ${$opacity};`}
	${({ $indent }) => $indent !== undefined ? typeof $indent === "number" ? `padding-left: ${$indent}rem;` : `padding-left: 1rem;` : ""}
	${({ $bold }) => $bold && `font-weight: 700;`}
	${({ $margin }) => $margin !== undefined && `margin: ${$margin};`}
	${({ $debug }) => $debug && `background-color: red!important;`}
	${({ $nowrap }) => $nowrap && `white-space: nowrap;`}
	${({ $light }) => $light && `color: ${getTheme().surface_light}!important;`}
	${({ $dark }) => $dark && `color: ${getTheme().surface_dark};`}
	${({ $lineHeight }) => $lineHeight && `line-height: ${$lineHeight};`}
	${({ $font }) => $font && `font-family: ${getTheme().fonts[$font] || $font};`}

`;


export const Label = styled(TextNode)``;
export const Title = styled(TextNode)``;
export const Subtitle = styled(TextNode)``;
export const Caption = styled(TextNode)``;
export const FootNote = styled(TextNode)``;
